var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"controller",class:_vm.getClassStatus,attrs:{"disabled":_vm.isDisabled},on:{"click":_vm.clickEvent}},[_c('icon',{staticClass:"relative",attrs:{"name":_vm.icon_type[_vm.type]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }